import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { APP_CONFIG } from '@boma/app-config';
import {
  IDepartment,
  IPaginatedResponse,
  IProduct,
  ISearchFacetResponse
} from "@boma/website/shared/entities";

@Injectable({
  providedIn: 'root',
})
export class SearchService {
  private base: string;
  private version: string;
  constructor(
    @Inject(APP_CONFIG) private configuration: any,
    private httpClient: HttpClient
  ) {
    this.base = configuration.apiRoute;
    this.version = configuration.apiVersion;
  }
  //TODO searchMode
  searchProducts(
    page: number = 1,
    perPage: number = 25,
    query: string = '',
    categoryIds: string[] = [],
    filters: { key: string; value: string }[] = [],
    operatingLocationId: string = null,
    operatingEntityId: string = null,
    supplierId: string = null,
    brandId: string = null,
    definitionIds: string[] = []
  ) {
    const queryParams = [];
    let urlQuery = '';

    if (page) {
      queryParams.push(`page=${page}`);
    }
    if (perPage) {
      queryParams.push(`perPage=${perPage}`);
    }
    if (query) {
      queryParams.push(`query=${query}`);
    }
    if (filters && filters.length) {
      const filterValue = filters.map((f) => `${f.key}:${f.value}`).join('|');
      queryParams.push(`filters=${filterValue}`);
    }
    if (operatingLocationId) {
      queryParams.push(`operatingLocationId=${operatingLocationId}`);
    }
    if (operatingEntityId) {
      queryParams.push(`operatingEntityId=${operatingEntityId}`);
    }
    if (supplierId) {
      queryParams.push(`supplierId=${supplierId}`);
    }
    if (brandId) {
      queryParams.push(`brandId=${brandId}`);
    }
    if (queryParams.length > 0) {
      urlQuery = `?${queryParams.join('&')}`;
    }

    return this.httpClient.post<IPaginatedResponse<IProduct>>(
      `${this.base}api/v${this.version}/Search/Products${urlQuery}`,
      { definitionIds, categoryIds }
    );
  }

  getProductFacets(
    query: string = '',
    categoryId: string = null,
    departmentId: string = null,
    operatingLocationId: string = null,
    operatingEntityId: string = null,
    supplierId: string = null,
    brandId: string = null
  ) {
    let queryParams = [];
    let urlQuery = '';

    if (query) {
      queryParams.push(`query=${query}`);
    }
    if (categoryId) {
      queryParams.push(`categoryId=${categoryId}`);
    }
    if (departmentId) {
      queryParams.push(`departmentId=${departmentId}`);
    }
    if (operatingLocationId) {
      queryParams.push(`operatingLocationId=${operatingLocationId}`);
    }
    if (operatingEntityId) {
      queryParams.push(`operatingEntityId=${operatingEntityId}`);
    }
    if (supplierId) {
      queryParams.push(`supplierId=${supplierId}`);
    }
    if (brandId) {
      queryParams.push(`brandId=${brandId}`);
    }
    if (queryParams.length > 0) {
      urlQuery = `?${queryParams.join('&')}`;
    }
    return this.httpClient.get<ISearchFacetResponse>(
      `${this.base}api/v${this.version}/Search/Products/Facets${urlQuery}`
    );
  }

  getSuggestions(
    query: string = '',
    categoryId: string = null,
    operatingLocationId: string = null,
    operatingEntityId: string = null
  ) {
    let queryParams = [];
    let urlQuery = '';
    if (query) {
      queryParams.push(`query=${query}`);
    }
    if (categoryId) {
      queryParams.push(`categoryId=${categoryId}`);
    }
    if (operatingLocationId) {
      queryParams.push(`operatingLocationId=${operatingLocationId}`);
    }
    if (operatingEntityId) {
      queryParams.push(`operatingEntityId=${operatingEntityId}`);
    }

    if (queryParams.length > 0) {
      urlQuery = `?${queryParams.join('&')}`;
    }
    return this.httpClient.get<any>(
      `${this.base}api/v${this.version}/Search/Products/Suggestions${urlQuery}`
    );
  }

  getInformalListings(
    page: number = 1,
    perPage: number = 25,
    productId: string = null,
    operatingLocationId: string = null,
    operatingEntityId: string = null,
    listingType: string = null, // Buying Selling
    maximumDistance: number = 50,
    definitionIds: string[] = []
  ) {
    let queryParams = [];
    let urlQuery = '';

    if (page) {
      queryParams.push(`page=${page}`);
    }
    if (perPage) {
      queryParams.push(`perPage=${perPage}`);
    }
    if (productId) {
      queryParams.push(`productId=${productId}`);
    }
    if (operatingLocationId) {
      queryParams.push(`operatingLocationId=${operatingLocationId}`);
    }
    if (operatingEntityId) {
      queryParams.push(`operatingEntityId=${operatingEntityId}`);
    }
    if (listingType) {
      queryParams.push(`type=${listingType}`);
    }
    if (maximumDistance) {
      queryParams.push(`maximumDistance=${maximumDistance}`);
    }

    if (queryParams.length > 0) {
      urlQuery = `?${queryParams.join('&')}`;
    }

    return this.httpClient.get<IPaginatedResponse<IProduct>>(
      `${this.base}api/v${this.version}/Search/Products${urlQuery}`
    );
  }

  getDepartments(query: string = '') {
    let urlQuery = '';

    if (query) {
      urlQuery = `?query=${query}`;
    }

    return this.httpClient.get<IDepartment[]>(
      `${this.base}api/v${this.version}/Departments${urlQuery}`
    );
  }


  getGlobalKPI(){
    return this.httpClient.get<any>(
      `${this.base}api/v2.0/KPI`
    );
  }
}
